module.exports = __webpack_public_path__ + "static/img/318_TO8_2480_og.9f92160.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/318_TO8_2480_og.jpg
// module id = xl7+
// module chunks = 0